import Resource from './Resource';
import {
	StandardIntegrationDataRequest,
	StandardIntegrationDataResponse
} from 'App/resources/Model/StandardIntegrationData';

type RequestOpts = { params?: Record<string, unknown> };

class StandardIntegrationDataResource extends Resource {
	constructor() {
		super('function/standardIntegrationData');
	}

	/**
	 * Posts the body untouched. Deliberately bypasses `save()` — its `mapDates` step rewrites every
	 * Date/ISO string through `moment.tz(Tools.userTimezone)`, which would change (and, on a browser
	 * in another timezone, shift) the timestamps the integration app receives.
	 */
	run<ResponseData = any>(
		data: StandardIntegrationDataRequest,
		opts: RequestOpts = {}
	): Promise<StandardIntegrationDataResponse<ResponseData>> {
		return this._postRequest('', data, { methodName: 'run', ...opts }).then(
			(res: { data: StandardIntegrationDataResponse<ResponseData> }) => res.data
		);
	}

	test<ResponseData = any>(data: StandardIntegrationDataRequest, opts: RequestOpts = {}) {
		return this.run<ResponseData>({ ...data, type: 'test' }, opts);
	}

	values<ResponseData = any>(data: StandardIntegrationDataRequest, opts: RequestOpts = {}) {
		return this.run<ResponseData>({ ...data, type: 'values' }, opts);
	}

	oauth<ResponseData = any>(data: StandardIntegrationDataRequest, opts: RequestOpts = {}) {
		return this.run<ResponseData>({ ...data, type: 'oauth' }, opts);
	}
}

const resource = new StandardIntegrationDataResource();

export default resource;
